<header class="ib-modals__header ">
    <div class="ib-layout__line-spacing ib-layout__line-spacing--xsmall">
        <h2 class="ib-heading ib-heading--type-1">{{'MMB_VOLUNTARY_REFUNDS_LEAVE_MODAL_TITLE' | translate}}</h2>
    </div>
    <div class="ib-modals__header-settings">
        <button focusin type="button" class="ib-modals__button-action icon-cerrar" (click)="closeModal()">
            <span class="u-hide-accessible">{{'GENERIC_MODAL_ACCESSIBLE_CLOSE' | translate}}</span>
        </button>
    </div>
</header>
<section class="ib-modals__body ">
    <div class="ib-layout__line-spacing">
        <p class="ib-text">{{'MMB_VOLUNTARY_REFUNDS_LEAVE_MODAL_BODY' | translate}}</p>
    </div>
</section>
<footer class="ib-modals__footer">
    <div class="ib-content-buttons">
        <div class="ib-content-buttons__content-left">
            <button class="ib-button" type="button" (click)="closeAllModal()">
                {{'MMB_VOLUNTARY_REFUNDS_LEAVE_MODAL_CTA' | translate}}
            </button>
        </div>
        <div class="ib-content-buttons__content-right">
            <a href="javascript:void(0)" title="{{'MMB_VOLUNTARY_REFUNDS_LEAVE_MODAL_CTA_SEC' | translate}}"
                class="ib-link" (click)="closeModal()">{{'MMB_VOLUNTARY_REFUNDS_LEAVE_MODAL_CTA_SEC' | translate}}
            </a>
        </div>
    </div>
</footer>
